import { Header } from "./Header.";
import Footer from "./Footer";
import React from "react";
import { useState, useEffect } from "react";
import axios from "axios"
import { useParams } from "react-router-dom";
import "./Styles/collectionPage.css"
import BasicCard from "./BasicCard";

export const CollectionPage = () => {
    const [collection, setCollection] = useState({})
    const params = useParams();
    const collectionsURL = process.env.REACT_APP_API_BASE_URL + '/images/collections/';

    useEffect(() => {
        let slug = params.slug;

        axios.get(process.env.REACT_APP_API_BASE_URL + '/api/product_collections?groups[]=collection_details&slug=' + slug, {
            headers: {
                'x-api-token': process.env.REACT_APP_API_TOKEN
            }
        }).then(a => {
            setCollection(a.data[0]);

            document.title = a.data[0].name+" - KabaaShop";
        }).catch(error => {
            console.log(error);
        })

    }, [true])

    let displayResults = [];

    if(collection.products){
        collection.products.map((x, index)=>{
            displayResults.push(
                <div href={"/boutique/"+x.slug} key={'productResult'+index} className="collection-product-item">
                    <BasicCard product={x} />
                </div>
            )
        })
    }

    return (
        <>
            <Header />
            <div style={{backgroundImage: "url("+collectionsURL+collection.image+")"}} className="collection-header">
                <h1>{collection.name}</h1>
            </div>
            <div className="collection-products-container">
                {displayResults}
            </div>
            <Footer />
        </>
    );
};
